import styled from "styled-components";

export const LoadMoreButton = styled.button`
    margin: 15px auto;
    padding: 8px 16px;

    font-size: 16px;
    color: #edf3fc;
    background-color: #db7093;
    box-shadow: 0 4px 10px #0000000d;
    border-radius: 2px;
    transition: background-color 250ms linear;
    &:hover {
        background-color: #e899b3;
    }
`
